import { Button, Form, Input, Radio } from "antd";
import { Link } from "react-router-dom";

export default function MobileLogin({ onsubmit, isLoading }) {
  const [form] = Form.useForm();

  return (
    <Form form={form} onFinish={onsubmit} layout="vertical">
      <Form.Item name="type" initialValue="mobile" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="type_value" rules={[{ required: true, message: "Please enter your mobile number!" }]}>
        <Input className="login_field" type="text" maxLength="12" name="type_value" placeholder="Mobile number" />
      </Form.Item>
      <Form.Item name="provider" initialValue="mpki" label="Provider:">
        <Radio.Group>
          <Radio value="mpki">Mobile ID</Radio>
          <Radio value="gasr">App ID</Radio>
        </Radio.Group>
      </Form.Item>
      <Button block shape="round" loading={isLoading} className="login_button" htmlType="submit">
        Continue
      </Button>
      <div style={{ textAlign: "center", paddingTop: 20 }}>
        <Link className="login_link" to="/login/email">
          Login with email
        </Link>
      </div>
      <div style={{ textAlign: "center", paddingTop: 20 }}>
        <Link className="login_link" to="/login/forgot">
          Forgot Password?
        </Link>
      </div>
    </Form>
  );
}
